import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: '浏览内容',
    links: [
      { label: '首页', to: '/' },
      { label: '影视分类', to: '/category/movie' },
      { label: '短视频分类', to: '/category/short' },
      { label: '直播专区', to: '/category/live' },
    ],
  },
  {
    title: '互动与帮助',
    links: [
      { label: '视频社交', to: '/community' },
      { label: '搜索资源', to: '/search' },
      { label: '关于我们', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full px-4 pb-24 pt-12 md:px-6 md:pb-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">麻豆精品入口蜜桃</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
              多元化综合娱乐平台，聚焦影视视频资源、娱乐内容分类展示与轻量社交互动，为喜爱影视与高清视频的用户提供清晰便捷的浏览体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-500 transition-colors hover:bg-primary-100 hover:text-primary-600"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-900">
                <a href={col.links[0].to} className="hover:text-primary-600">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 麻豆精品入口蜜桃 · 多元化娱乐资源平台 · 本站内容仅为前端演示示例</p>
          <p>温馨提示：本站不提供真实视频播放与发布服务，请理性浏览娱乐内容</p>
        </div>
      </div>
    </footer>
  );
}